<template>
	<DefaultTemplate>
		<div class="card rounded pd-1">
			<b-tabs v-model="activeTab">
            	<b-tab-item label="Admin">
					<AdminList/>
            	</b-tab-item>
            	<b-tab-item label="Staff">
            		<StaffList/>
            	</b-tab-item>
            </b-tabs>
		</div>
	</DefaultTemplate>
</template>
<script>
import DefaultTemplate from '@/template/DefaultTemplate'
import AdminList from '@/components/User/AdminList'
import StaffList from '@/components/User/StaffList'
import { HTTP } from "@/service/axios.js";
import {
    alertFailError,
    alertCatchError
} from "@/service/alert";

export default {
    components:{
    	StaffList,
    	AdminList,
        DefaultTemplate
    },
    data(){
    	return{
    		activeTab: 0,
    	}
    }
}
</script>